import React, { useState } from 'react';

import Product from './Product'
import Company from './Company'
import Footer from './Footer'

function App() {
  const [currentPage, setCurrentPage] = useState('product')

  return (
    <div
      style={{ margin: '3% 10%'}}
    >      
      <div
          style={{            
              marginLeft: '10%',
              paddingBottom: '1rem',              
          }}
      >
          <a
              style={{
                  color: '#999',
                  fontSize: '0.8rem',
                  paddingRight: '1rem'
              }}
              href="#"
              onClick={() => setCurrentPage('product')}
          >
              홈
          </a>
          <a
              style={{
                  color: '#999',
                  fontSize: '0.8rem',
                  paddingRight: '1rem'
              }}
              href="#"
              onClick={() => setCurrentPage('company')}
          >
              회사 소개
          </a>
      </div>
      {
        currentPage === 'product' ? <Product/> : <Company/> 
      }    
      <Footer setCurrentPage={setCurrentPage}/>       
    </div> 
  ) 
}

export default App;
